import { useState } from "react";
import "./App.css";
import Header from "./Components/Header";
import { useTranslation } from "react-i18next";
// import CourseCard from "./Components/CourseCard";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel as RCarousel } from "react-responsive-carousel";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  LineOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  PhoneFilled,
} from "@ant-design/icons";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import AdvantageCard from "./Components/Advantages";
import { importAndSortCourseImages } from "./utils/importCourses";
import { YMaps, Map, Placemark } from "@pbe/react-yandex-maps";

const courseImages = importAndSortCourseImages();

function importAll(r) {
  return r
    .keys()
    .map(r)
    .map((m) => m.default || m);
}
let images = importAll(
  require.context("./assets/gallery", false, /\.(jpe?g|png|webp)$/)
);

// 2️⃣ (Optional) Shuffle for random gallery
images = images.sort(() => Math.random() - 0.5);

// 3️⃣ Chunk into slides: single, then a stack of two, repeating
const slides = [];
for (let i = 0; i < images.length; ) {
  // single image slide
  slides.push({ type: "single", src: images[i] });
  i += 1;
  // stacked slide if at least two images remain
  if (i + 1 < images.length) {
    slides.push({
      type: "stack",
      images: [images[i], images[i + 1]],
    });
    i += 2;
  }
}

let certificateImages = importAll(
  require.context("./assets/certificates", false, /\.(jpe?g|png|webp)$/)
);

// 2️⃣ (Optional) Shuffle for random gallery
certificateImages = certificateImages.sort(() => Math.random() - 0.5);

// 3️⃣ Chunk into slides: single, then a stack of two, repeating
const certificates = [];
for (let i = 0; i < certificateImages.length; ) {
  // single image slide
  certificates.push({ type: "single", src: certificateImages[i] });
  i += 1;
  // stacked slide if at least two images remain
  if (i + 1 < certificateImages.length) {
    certificates.push({
      type: "stack",
      images: [certificateImages[i], certificateImages[i + 1]],
    });
    i += 2;
  }
}

function App() {
  const notify = (message) => toast(message);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    status: "awaiting",
  });
  const [sending, setSending] = useState(false);
  const [phoneExists, setPhoneExists] = useState(false);
  const [resultsCarousel, setResultsCarousel] = useState({
    current: 1,
    total: 12,
    name: "Ataxanova Yulduz",
    university: "Urganch davlat universiteti Filologiya va tillari o'qitish",
    scholarship: "1-GRANT",
  });
  const [t] = useTranslation("common");

  const handleCustomPrevClick = () => {
    // Handle previous slide logic here
    const nextButton = document.querySelector(".carousel-prev-arrow");
    if (nextButton) {
      nextButton.click();
    }
  };

  const handleCustomNextClick = () => {
    // Handle next slide logic here
    const nextButton = document.querySelector(".carousel-next-arrow");
    if (nextButton) {
      nextButton.click();
    }
  };

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1280 },
      items: 4,
      partialVisibilityGutter: 40,
    },
    desktop: {
      breakpoint: { max: 1279, min: 1024 },
      items: 3,
      partialVisibilityGutter: 30,
    },
    tablet: {
      breakpoint: { max: 1023, min: 464 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    mobile: {
      breakpoint: { max: 463, min: 0 },
      items: 1,
      partialVisibilityGutter: 20,
    },
  };

  const advantages = [
    {
      icon: require("./assets/education-quality-monitoring.png"),
      title: t("advantages.quality.title"),
      desc: t("advantages.quality.desc"),
    },
    {
      icon: require("./assets/academic-support.png"),
      title: t("advantages.support.title"),
      desc: t("advantages.support.desc"),
    },
    // {
    //   icon: require("./assets/innovation.png"),
    //   title: t("advantages.innovation.title"),
    //   desc: t("advantages.innovation.desc"),
    // },
    {
      icon: require("./assets/professionals.png"),
      title: t("advantages.professionals.title"),
      desc: t("advantages.professionals.desc"),
    },
  ];

  const teachers = [
    {
      src: require("./assets/teachers/2.png"),
      alt: "Teacher 1",
      name: "Qo'ziboyev Umarbek Ulugbekovich",
      desc: t("team.umarbek"),
    },
    {
      src: require("./assets/teachers/3.png"),
      alt: "Teacher 2",
      name: "Abdullayeva Barno Qodirovna",
      desc: t("team.barno"),
    },
    {
      src: require("./assets/teachers/4.png"),
      alt: "Teacher 3",
      name: "Hajiyev Ulug'bek Qo'ziboyevich",
      desc: t("team.ulugbek"),
    },
  ];

  return (
    <div className="App w-full overflow-x-hidden">
      <Header />
      <div className="mx-auto flex justify-between max1024:flex-col px-8 max-w-[1440px] mb-8">
        <div className="flex flex-col items-start justify-center p-8 mt-4 rounded-[1rem] flex-1">
          <h2 className="my-3 text-[#003d65] text-3xl font-bold">
            {t("header.title")}
          </h2>
          <p className="text-black max-w-[500px]">{t("header.desc")}</p>
          <a
            href="https://md.leaderonline.uz"
            // onClick={() => navigate("/signin")}
            className="transition-all my-3 bg-[#fe7104] hover:bg-[#ff9346] p-4 text-white rounded-[20px] text-2xl font-medium"
          >
            {t("header.button")}
          </a>
        </div>
        <div className="flex-1 flex justify-center items-center">
          <img
            className="max1024:max-w-[300px] max-w-[500px] h-auto object-contain"
            src={require("./assets/header-pic.png")}
            alt="learning lamp"
          />
        </div>
      </div>

      <div
        style={{
          background: "#60a5fa",
          clipPath: "polygon(0 10%, 100% 0, 100% 90%, 0 100%)",
          padding: "100px 0",
        }}
        className="relative flex justify-between flex-col min-h-[400px] py-20 bg-blue-400"
      >
        <div className="absolute w-72 h-72 bg-[#4499ff] rounded-full -right-20 -top-10 -z-50"></div>
        <div className="absolute w-56 h-56 bg-[#4499ff] rounded-full -left-20 -bottom-10 -z-50"></div>
        <div className="mx-auto max-w-[1440px]">
          <div className="max-w-[90%] mx-auto py-8 flex max1024:flex-wrap gap-4 text-base font-bold">
            <p className="xm:text-3xl font-bold text-4xl max1024:text-center">
              {t("footer.request")}
            </p>
            <p className="max-w-[400px] text-base font-bold">
              {t("footer.subscribe")}
            </p>
          </div>
          <form
            action="https://formbold.com/s/3qAwn"
            method="POST"
            className="my-3 max-w-[90%] mx-auto flex flex-wrap flex-row justify-center gap-4 max1024:flex-col"
          >
            <div className="flex justify-center min-w-[300px] max-w-full">
              <input
                className="w-full outline-none p-6 bg-transparent text-black border border-black placeholder:text-black text-2xl"
                type="text"
                placeholder={t("footer.first")}
                required
                name="firstname"
                value={formData.firstName}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    firstName: e.target.value,
                  }))
                }
              />
            </div>
            <div className="flex justify-center min-w-[300px] max-w-full">
              <input
                className="w-full outline-none p-6 bg-transparent text-black border border-black placeholder:text-black text-2xl"
                type="number"
                placeholder="+998 (__) ___-__-__"
                required
                name="phone"
                value={formData.phone}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, phone: e.target.value }))
                }
              />
            </div>
            <div className="flex justify-center max-w-full min-w-[300px]">
              <button
                type="submit"
                // onClick={() => onSubmit()}
                className="w-full bg-[#fe7104] text-white font-semibold py-4 text-3xl uppercase"
              >
                {t("footer.send")}
              </button>
            </div>
          </form>
        </div>
      </div>

      <div
        id="courses"
        className="mx-auto flex flex-wrap lg:flex-col my-8 gap-4 max-w-[1440px] "
      >
        <h3 className="text-center w-full text-3xl font-bold py-3">
          {t("courses.courses")}
        </h3>
        <div className="w-full mx-auto max-w-screen-lg">
          {/* ← now the carousel will never stretch beyond 1024px */}
          <Carousel
            responsive={responsive}
            infinite
            arrows
            draggable
            swipeable
            autoPlay={true}
            autoPlaySpeed={6000}
            pauseOnHover={true}
            containerClass="flex items-stretch gap-x-5"
            itemClass="flex-shrink-0 w-[280px] sm:w-[320px] md:w-[360px] h-[600px] px-2"
          >
            {courseImages.map((src, idx) => (
              <div
                key={idx}
                className="overflow-hidden rounded-3xl bg-white h-full"
              >
                <img
                  src={src}
                  className="h-full w-full object-cover rounded-2xl"
                  alt={`Courses ${idx}`}
                />
              </div>
            ))}
          </Carousel>
        </div>
      </div>

      <div id="advantages" className="mx-auto py-8 max-w-[1440px] ">
        <h3 className="text-center text-3xl font-bold">
          {t("advantages.advantages")}
        </h3>

        <div className="relative flex flex-wrap justify-center gap-8 my-8">
          {advantages.map(({ icon, title, desc }, i) => (
            <AdvantageCard
              key={i}
              icon={icon.default || icon}
              title={title}
              desc={desc}
            />
          ))}
        </div>
      </div>

      <div
        id="hybird"
        className="max-w-[1440px] relative mx-auto flex max1024:flex-col max768:flex-col items-center max1440:max-w-[90%] bg-blue-100 rounded-[2rem] overflow-hidden p-6 md:p-12 shadow-xl"
      >
        {/* Background circles */}
        <div className="absolute w-72 h-72 bg-blue-200 rounded-full -right-20 -top-10"></div>
        <div className="absolute w-56 h-56 bg-blue-400 rounded-full -left-8 top-24"></div>

        <div className="relative  z-10 w-full md:w-1/2 flex justify-center md:justify-start">
          <img
            src={require("./assets/innovation.png")}
            alt="Hybrid learning system"
            className="w-3/4 md:w-full max-w-sm drop-shadow-lg"
          />
        </div>
        <div className="relative sm:text-center xm:text-center xs:text-center z-10 w-full md:w-1/2 text-left">
          <h2 className="text-2xl md:text-3xl font-extrabold mb-4">
            {t("advantages.innovation.title")}
          </h2>
          <p className="font-bold max-w-xs text-base md:text-lg sm:max-w-full xm:max-w-full xs:max-w-full leading-relaxed text-gray-800">
            {t("advantages.innovation.desc")}
          </p>
        </div>
      </div>

      <section
        id="teachers"
        className="max-w-[1440px] mx-auto relative flex justify-center md:mx-8 lg:mx-8  px-4 py-16"
      >
        <div className="absolute -left-20 -top-10 w-48 h-48 bg-teal-100 rounded-full -z-50"></div>
        <div className="absolute -right-20 -bottom-10 w-48 h-48 bg-cyan-100 rounded-full"></div>

        <div className="relative bg-blue-100 rounded-[2rem] p-8 max768:p-12 max1024:p-16 max-w-5xl w-full shadow-xl">
          <h2 className="text-center text-3xl max768:text-2xl font-extrabold mb-12">
            {t("team.ourteam")}
          </h2>

          <div className="flex flex-col gap-4 justify-center items-center space-y-6 sm:space-y-0">
            {teachers.map(({ src, alt, name, desc }, i) => (
              <div className="flex items-center max768:flex-col max768:h-auto bg-blue-50 rounded-[2rem] p-6 w-full h-48 shadow-lg">
                <p className="w-1/4 max768:w-auto max500:text-center text-lg font-bold">
                  {name}
                </p>
                <img
                  src={src.default || src}
                  alt={alt}
                  className="w-60 h-60 rounded-full object-contain mx-4 flex-shrink-0"
                />
                <p className="w-2/4 max768:w-auto text-bold">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div
        id="about"
        className="mx-auto max-w-[1440px] flex flex-wrap lg:flex-col my-8 gap-4"
      >
        <h3 className="text-center w-full text-3xl font-bold py-3 uppercase">
          {t("gallery.title")}
        </h3>
        <div className="w-full mx-auto max-w-screen-lg">
          <Carousel
            responsive={responsive}
            infinite
            arrows
            draggable
            swipeable
            autoPlay={true}
            autoPlaySpeed={4000}
            pauseOnHover={true}
            containerClass="flex items-stretch gap-x-5"
            itemClass="flex-shrink-0 w-[280px] sm:w-[320px] md:w-[360px] h-[600px] px-2"
          >
            {slides.map((slide, idx) => (
              <div
                key={idx}
                className="overflow-hidden rounded-3xl bg-white h-full"
              >
                {slide.type === "single" ? (
                  <img
                    src={slide.src}
                    className="h-full w-full object-cover rounded-2xl"
                    alt={`Gallery ${idx}`}
                  />
                ) : (
                  <div className="flex flex-col gap-y-5 h-full">
                    {slide.images.map((src, i) => (
                      <img
                        key={i}
                        src={src}
                        className="h-1/2 w-full object-cover rounded-2xl"
                        alt={`Gallery stack ${idx}-${i}`}
                      />
                    ))}
                  </div>
                )}
              </div>
            ))}
          </Carousel>
        </div>
      </div>

      <div id="results" className="mx-auto max-w-[1440px] relative px-8 my-20">
        <h3 className="text-center text-3xl py-3 font-bold">
          {t("results.results")}
        </h3>

        <div className="w-full mx-auto max-w-screen-lg">
          <Carousel
            responsive={responsive}
            infinite
            arrows
            draggable
            swipeable
            autoPlay={true}
            autoPlaySpeed={4000}
            pauseOnHover={true}
            containerClass="flex items-stretch gap-x-5"
            itemClass="flex-shrink-0 w-[280px] sm:w-[320px] md:w-[360px] h-[600px] px-2"
          >
            {certificates.map((slide, idx) => (
              <div
                key={idx}
                className="overflow-hidden rounded-3xl bg-white h-full"
              >
                {slide.type === "single" ? (
                  <img
                    src={slide.src}
                    className="h-full w-full object-contain rounded-2xl"
                    alt={`Certificates ${idx}`}
                  />
                ) : (
                  <div className="flex flex-col gap-y-5 h-full">
                    {slide.images.map((src, i) => (
                      <img
                        key={i}
                        src={src}
                        className="h-1/2 w-full object-contain rounded-2xl"
                        alt={`Gallery stack ${idx}-${i}`}
                      />
                    ))}
                  </div>
                )}
              </div>
            ))}
          </Carousel>
        </div>
      </div>

      <footer className="bg-[#dcdcff] text-black min-h-[500px]">
        <div className="mx-auto flex flex-row md:flex-col sm:flex-col xm:flex-col xs:flex-col p-8 h-full">
          <div className="bg-[#dcdcff] p-8  rounded-lg">
            <h3 className="text-2xl font-bold mb-4 uppercase">
              {t("footer.contact")}
            </h3>
            <p className="pb-2">
              <MailOutlined style={{ fontSize: "26px", paddingRight: "8px" }} />
              leaderlearningcentre@gmail.com
            </p>
            <p className="pb-2">
              <PhoneOutlined
                style={{ fontSize: "26px", paddingRight: "8px" }}
              />
              +998904303155
            </p>
            <p className="pb-2">
              <EnvironmentOutlined
                style={{ fontSize: "26px", paddingRight: "8px" }}
              />{" "}
              Urganch sh, P. Mahmud ko'chasi
            </p>
          </div>

          <div className="flex-grow h-[500px] overflow-hidden shadow-inner rounded-lg">
            <YMaps>
              <Map
                defaultState={{ center: [41.5689495, 60.6033868], zoom: 17 }}
                width="100%"
                height="100%"
              >
                {/* Optional: Add a placemark at the exact address */}
                <Placemark geometry={[41.5689495, 60.6033868]} />
              </Map>
            </YMaps>
          </div>
        </div>
      </footer>

      <div
        id="contacts"
        className="flex items-center justify-between flex-wrap bg-[#dcdcff] p-4 border-t border-black max768:flex-col max768:gap-4"
      >
        <p className="text-xs font-bold">leaderlearningcentre@gmail.com</p>
        <div className="flex gap-4">
          <a href="https://www.facebook.com/leader.learning.centre">
            <img
              className="w-8 object-contain"
              src={require("./assets/facebook.png")}
              alt=""
            />
          </a>
          <a href="http://instagram.com/leader_learning_centre">
            <img
              className="w-8 object-contain"
              src={require("./assets/instagram.png")}
              alt=""
            />
          </a>
          <a href="https://t.me/leader_learning_centre">
            <img
              className="w-8 object-contain"
              src={require("./assets/telegram.png")}
              alt=""
            />
          </a>
        </div>
        <p className="text-xs font-bold">
          © 2025 Leader Learning Centre. All rights reserved.
        </p>
      </div>
      <ToastContainer />
      <a
        href="tel:+998904303155"
        className="fixed bottom-8 right-8 w-14 h-14 flex items-center justify-center rounded-full bg-[#fe7204] shadow-lg z-50 hover:scale-110 transition-transform"
        title="Позвонить"
      >
        <PhoneFilled className="text-white text-3xl" />
      </a>
    </div>
  );
}

export default App;
